import { useCallback } from 'react';
import { FormInstance } from 'antd';
import { handleFormError, onFormFinishFailed } from '@/shared/utils/handler/error';

export const useFormErrorHandler = (form: FormInstance<any>) => {
  const handleApiError = useCallback(
    (error: any) => {
      handleFormError(error, form);
    },
    [form]
  );

  const handleValidationFailed = useCallback(
    (errorInfo: any) => {
      onFormFinishFailed(errorInfo);
    },
    []
  );

  return {
    handleApiError,
    handleValidationFailed,
  };
};

export default useFormErrorHandler;
